import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable } from 'knockout';
import TopicCommentFilterVM from './filter';
import './filterHeader.html';

export interface TopicCommentsFilterHeaderVMConfig<T = any> {
    filter: TopicCommentFilterVM<T>
}

@injectable()
export default class TopicCommentsFilterHeaderVM<T = any> {
    private filter: TopicCommentFilterVM<T>

    title: string
    icon: string

    isActive: Subscribable<boolean>
    
    constructor(
        @inject(wccModules.componentConfig) { filter }: TopicCommentsFilterHeaderVMConfig<T>,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
    ) {
        this.filter = filter;

        this.title = filter.title;
        this.icon = filter.icon;

        this.isActive = filter.isActive;

        ko.applyBindingsToNode(info.element, {
            'css': {
                'topic-comments-filters__filter__header': true
            }
        });
    }

    reset = () => {
        this.filter.reset();
    }
}